import Vue from 'vue'
import Router from 'vue-router'
import { API_APPS, ROUTER_MODE } from '@/api/config'
import { genericChildRoutes } from '@/router/generic'
import ApplicationView from '@/views/customer/services/ApplicationView'
import CustomerDetailView from '@/views/customer/CustomerDetailView'
import CaseView from '@/views/customer/CaseView'
import CaseInvoiceView from '@/views/customer/CaseInvoiceView'
import CaseReviewView from '@/views/customer/caseReview/CaseReviewView'
import CaseReviewFindingsView from '@/views/customer/caseReview/CaseReviewFindingsView'
import AuthUser from '@/classes/auth/AuthUser'
import DashboardView from '@/views/customer/dashboard/DashboardView'
import InvoicingView from '@/views/customer/InvoicingView'
import DocumentsView from '@/views/customer/DocumentsView'
import CustomerEditView from '@/views/customer/CustomerEditView'
import CertificatesListView from '@/views/customer/CertificatesListView'
import CertificateDetailView from '@/views/customer/CertificateDetailView'
import CustomerCasesView from '@/views/customer/CustomerCasesView'
import ReportsUpcomingView from '@/views/customer/ReportsUpcomingView'
import ApplyForServiceView from '@/views/customer/services/ApplyForServiceView'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'DashboardView',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/application/:code',
    name: 'ApplicationView',
    component: ApplicationView,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/apply-for-service',
    name: 'ApplyForServiceView',
    component: ApplyForServiceView,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    component: CustomerDetailView,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'InvoicingView',
        component: InvoicingView
      },
      {
        path: 'documents',
        name: 'DocumentsView',
        component: DocumentsView
      },
      genericChildRoutes.MessagingView
    ]
  },
  {
    path: '/cases',
    name: 'CustomerCasesView',
    component: CustomerCasesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/cases/:caseId',
    component: CaseView,
    props: true,
    meta: { requiresAuth: true },
    children: [
      genericChildRoutes.CaseView,
      {
        path: 'invoices',
        name: 'CaseInvoiceView',
        component: CaseInvoiceView,
        props: true
      }
    ]
  },
  {
    path: '/cases/:caseId/review',
    component: CaseReviewView,
    props: true,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'CaseReviewFindingsView',
        component: CaseReviewFindingsView,
        props: true
      }
    ]
  },
  {
    path: '/profile/edit',
    name: 'CustomerEditView',
    component: CustomerEditView,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/certificates',
    name: 'CertificatesListView',
    component: CertificatesListView,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/certificates/:certificateId',
    component: CertificateDetailView,
    props: true,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'ReportsUpcomingView',
        component: ReportsUpcomingView,
        props: true
      },
      genericChildRoutes.ReportsCompletedView
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  base: 'customer/',
  mode: ROUTER_MODE,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!AuthUser.isLoggedIn()) {
      window.location.replace(API_APPS.PUBLIC + '/login')
    } else {
      if (AuthUser.isAdministrator()) {
        window.location.replace(API_APPS.ADMINISTRATOR)
      } else if (AuthUser.isAuditor()) {
        window.location.replace(API_APPS.AUDITOR)
      } else if (AuthUser.isManager()) {
        window.location.replace(API_APPS.MANAGER)
      } else if (AuthUser.isHR()) {
        window.location.replace(API_APPS.HR)
      } else {
        next()
      }
    }
  } else {
    next()
  }
})
export default router
